import { createApp } from 'vue';
import axios from 'axios';

import store from '@/store';
import { defaultVueErrorHandler } from '@/helpers/logger';

import './styles/app.scss';
import App from './App.vue';

// Axios setup
axios.defaults.withCredentials = true;
axios.defaults.baseURL = `${import.meta.env.VITE_API_URL}/api`;

const app = createApp(App);
app.config.errorHandler = defaultVueErrorHandler;

app.use(store);
app.mount('#app');
